export default __webpack_public_path__ + "static/media/Frame 504.6f9d63bd.svg";